<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@src/shared/stores/app-config';
import FooterLink from '@src/shared/ui/FooterLink.vue';

const { config } = storeToRefs(useAppConfigStore());
</script>

<template>
	<footer class="h-13.5 w-full border border-t-cardBorder hidden sm:flex items-center">
		<div class="max-w-7xl flex items-center mx-auto grow justify-between">
			<div v-if="config" class="flex items-center gap-8">
				<footer-link name="Discord" :link="config.socialUrls.discord" />
				<footer-link name="Telegram" :link="config.socialUrls.telegram" />
				<footer-link name="X / Twitter" :link="config.socialUrls.twitter" />
			</div>
			<div class="flex items-center gap-8">
				<template v-if="config">
					<footer-link name="Docs" :link="config.links.docs" />
					<footer-link name="Terms of use" :link="config.links.tos" />
				</template>
				<span class="text-secondaryText">© 2026 RStake</span>
			</div>
		</div>
	</footer>
</template>

<style scoped></style>
